const message = {
  select: "sélectionner",
  team: "équipe",
  submit: "soumettre",
  collaborator: "collaborateur",
  create: "créer",
  site: "site",
  categories: "catégories",
  download: "télécharger",
  totalHours: "heures totales",
  gived_polyvalence: "polyvalence donnée",
  received_polyvalence: "polyvalence reçue",
  polyvalence: "polyvalence",
  total: "total",
  edit: "modifier",
  remove: "supprimer",
  date: "date",
  restore: "restaurer",
  areYouSure: "Êtes-vous sûr ?",
  restoreProcess: "vous êtes sur le point de restaurer un processus supprimé!",
  yes_i_understand: "Oui, je comprends",
  cancel: "annuler",
  showDeletedProcesses: "afficher les processus supprimés",
  update: "mise à jour",
  restore_description: "vous êtes sur le point de restaurer un processus supprimé",
  deleteDescription: "vous êtes sur le point de supprimer un processus",
  requiredFieldsAreMissing: "les champs obligatoires sont manquants",
  errNetwork: "service indisponible",
  err400: "données invalides",
  err403: "interdit",
  err404: "page introuvable",
  err409: "des données existent déjà",
  err500: "erreur de service",
  err501: "serveur non disponible",
  "Site not Found": "site introuvable",
  pending_save: "en attente de sauvegarde",
  hours_pending_save_description: "vous êtes sur le point de perdre les heures déclarées.",
  save: "enregistrer",
  ignore: "ignorer",
  destroyed_hours: "heures détruites",
  recovered_hours: "heures récupérées",
  saved_hours: "heures économisées",
  recovered_process: "processus récupéré",
  delete_category_description: "vous êtes sur le point de supprimer une catégorie",
  delete_site_description: "vous êtes sur le point de supprimer un site",
  deleted_category: "la catégorie est supprimée",
  deleted_site: "le site est supprimé",
  required_field: "champ obligatoire",
  required_field_category_description: "le champ de description est obligatoire",
  required_field_category_name: "le champ de nom est obligatoire",
  required_field_fedid_site_code: "le code du site fedid est requis",
  required_field_site_name: "le nom du site est obligatoire",
  required_field_site_code: "le code du site est obligatoire",
  created_category: "la catégorie est créée",
  created_site: "le site est créé",
  "Activity duration exceding 9 Hours.": "Durée de l'activité supérieure à 9 heures",
  change_your_site: "changez votre site",
  change_your_team: "changez votre équipe",
  change_your_email: "changez votre email",
  have_api_planning: "avoir une planification API",
  table_is_empty: "la table est vide",
  add_to_drive: "ajouter à mon Google Drive",
  configuration: "configuration",
  economic: "économique",
  explotation: "exploitation",
  account: "compte",
  hda: "hda",
  "Total Hours of whole activities is more than 9h.": "le total des heures d'activités entières est supérieur à 9h.",
  "bad request": "mauvaise demande",
  "page not found": "page introuvable",
  select_date: "sélectionner la date",
  select_week: "sélectionner la semaine",
  select_team: "sélectionner l'équipe",
  select_collaborator: "sélectionner un collaborateur",
  date_from: "de...",
  date_to: "a...",
  more_options: "plus d'options",
  close_dialog: "fermer la boîte de dialogue",
  where_you_have_worked: "où vous avez travaillé",
  when_you_have_worked: "quand tu auras travaillé",
  the_week_what_do_you_search: "la semaine, que cherches-tu",
  the_team_what_do_you_search: "l'équipe, que cherches-tu",
  the_collaborator_what_do_you_search: "le collaborateur, que cherches-tu",
  site_name: "nom du site",
  site_code: "code du site",
  fedid_site_code_openid: "code du site fedid openId",
  fedid_site_code: "code du site fedid",
  site_code_planning: "planification du centre de code du site",
  categoryName: "nom de la catégorie",
  category_description: "description de la catégorie",
  user_title: "nom d'utilisateur",
  total_hours_title: "total",
  total_hours_provider_title: "planification totale",
  difference_hours_title: "différence",
  hours_in_team_title: "heures en équipe",
  given_polyvalence_title: "polyvalence donnée",
  received_polyvalence_title: "polyvalence reçue",
  process: "processus",
  polyvalence_team: "équipe polycalence",
  hours: "heures",
  date_title: "date",
  name: "prenom",
  planning_code: "code du site dans planning",
  fedid_code: "code du site dans fedid",
  description: "description",
  reset_form: "reset form",
  provider_api: "is connected with planning",
  no: "non",
  yes: "oui",
  your_email_does_not_exist_in_the_app: "your profile does not existe in the app",
  we_can_create_a_fictitious_profile_in_a_fictitious_center:
    "you can create a foctitious profile in a fictitious center",
  you_are_about_to_create_a_fictitious_profile_in_a_fictitious_center:
    "you are about to create a fictitious profile in a fictitious center",
  the_value_should_between_0_and_9: "the quantity of hours should between 0h and 9h",
  excel: "excel",
  no_content: "there isn't content",
  "logistic process": "logistic process",
  total_hours: "total hours",
  planning: "planning",
  logistic_process: "process",
  dates_error: "dates error",
  date_from_is_later_than_date_to: "the initial date is later than end date",
  username: "username",
  dni: "id",
  uuid: "uuid",
  sap_number: "sap number",
  email: "email",
  select_site: "select a site",
  new_collaborator: "new collaborator",
  all_fields_are_required: "all fields are required",
  field_are_required: "field are required",
  sap_structure_number: "sap structure number",
  delete_team_description: "you are about to delete a team",
  "deleted/notDeleted": "deleted or not deleted",
  total_hda: "total hda",
  total_team: "total team",
  ask_support: "ticket soporte it",
  manual: "manually",
  is_manual_user: "is a manually user",
  sites: "sites",
  sites_where_has_access: "sites where has access",
  select_multi_vada: "select multi vada",
  change_site: "change to an other site",
  total_days: "total days",
  dont_forget_edit_form: "Do not forget to select sites",
  no_options: "No options avaiable",
  selected: "selected",
  clean_selection: "limpiar seleccion",
  process_form_name_placeholder: "Nom",
  process_form_description_placeholder: "Description",
  process_form_minutes_placeholder: "Min",
  process_form_max_hours_placeholder: "Heures max",
  cancel_registration: "Annuler l'inscription",
  loading_options: "Chargement des options...",
  registering: "Enregistrement...",
  register_entry: "Enregistrer l'entrée",
  field_name_example: "Ex: user_age",
  field_label_example: "Ex: Âge utilisateur",
  field_help_text_placeholder: "Texte d'aide...",
  field_select_placeholder_example: "Ex: Sélectionnez une option...",
  url_placeholder: "https://...",
  category_name_example: "Ex: Visite VIP",
  category_description_short_placeholder: "Description courte de la catégorie...",
  search_field_name_or_label: "Rechercher un champ par nom ou étiquette...",
  write_here: "Écrivez ici...",
  continue: "Continuer",
  custom_color: "Couleur personnalisée",
  select_a_color: "Sélectionnez une couleur",
  email_placeholder_default: "exemple@email.com",
  field_type_text: "Texte",
  field_type_number: "Numéro",
  field_type_select: "Sélection",
  field_type_checkbox: "Case à cocher",
  field_type_calendar: "Date",
  reserved_space: "Espace réservé",
  loading: "Chargement",
  no_data: "Aucune donnée",
  success: "Succès",
  error: "Erreur",
  not_found: "Introuvable",
  visitor_data_loaded: "Les données du visiteur ont été chargées avec succès",
  visitor_not_found_key_value: "Aucun enregistrement antérieur trouvé pour cette valeur",
  search_error: "Erreur lors de la recherche des données du visiteur",
  ok: "OK",
  unknown: "Inconnu",
  register_error: "Erreur d'inscription",
  error_500: "Erreur serveur inattendue",
  error_deleting: "Erreur lors de la suppression",
  language_spanish: "Espagnol",
  language_english: "Anglais",
  language_french: "Français",
  edit_field: "Modifier le champ",
  new_field: "Nouveau champ",
  edit_category: "Modifier la catégorie",
  config_fields_subtitle_edit: "Modifiez les données du champ existant.",
  config_fields_subtitle_create: "Définissez les propriétés et la configuration du nouvel input.",
  config_categories_subtitle: "Définissez le nom, la couleur et les champs qui composeront ce formulaire de catégorie.",
  validation_error: "Erreur de validation",
  updated_successfully: "Mis à jour correctement",
  created_successfully: "Créé correctement",
  form_error_loading_data: "Une erreur est survenue lors du chargement des données.",
  form_error_saving_retry: "Une erreur est survenue lors de l'enregistrement. Réessayez.",
  config_error_loading_available_sites: "Impossible de charger les sites disponibles.",
  config_error_loading_available_teams: "Impossible de charger les équipes disponibles.",
  config_error_loading_sites_list: "Impossible de charger la liste des sites.",
  config_error_loading_teams_list: "Impossible de charger la liste des équipes.",
  config_error_loading_list: "Impossible de charger la liste.",
  config_error_loading_categories_list: "Impossible de charger la liste des catégories.",
  config_error_loading_fields_list: "Impossible de charger la liste des champs.",
  config_error_saving_site: "Erreur lors de l'enregistrement du site",
  config_error_unexpected_server: "Erreur inattendue lors de la communication avec le serveur.",
  config_error_saving_team: "Erreur lors de l'enregistrement de l'équipe",
  config_error_saving_leader: "Erreur lors de l'enregistrement du leader",
  config_error_saving_category: "Erreur lors de l'enregistrement de la catégorie",
  config_error_deleting_site: "Erreur lors de la suppression du site",
  config_error_deleting_team: "Erreur lors de la suppression de l'équipe",
  config_error_deleting_leader: "Erreur lors de la suppression du leader",
  config_error_deleting_category: "Erreur lors de la suppression de la catégorie",
  config_error_deleting_field: "Erreur lors de la suppression du champ",
  config_error_loading_site_teams: "Impossible de charger les équipes de ce site.",
  config_error_loading_teams: "Erreur de chargement des équipes",
  config_error_loading_form_data: "Erreur lors du chargement des données du formulaire",
  config_error_saving_form: "Erreur lors de l'enregistrement du formulaire",
  visitors_error_loading_history: "Impossible de charger l'historique des visiteurs.",
  visitors_error_loading_categories: "Impossible de charger les catégories.",
  visitors_error_category_data_not_found: "Aucune donnée trouvée pour cette catégorie.",
  visitors_error_loading_form_config: "Impossible de charger la configuration du formulaire.",
  visitors_registered_successfully: "Le visiteur a été enregistré correctement.",
  visitors_error_registering: "Impossible d'enregistrer le visiteur. Réessayez.",
  exit_registered: "Sortie enregistrée",
  visitors_exit_registered_successfully: "La sortie du visiteur a été enregistrée correctement.",
  visitors_error_registering_exit: "Impossible d'enregistrer la sortie du visiteur.",
  visitors_invalid_date_range: "La date de fin doit etre egale ou posterieure a la date de debut.",
  visitors_missing_center_code: "Impossible de recuperer le code centre pour filtrer l'historique des visiteurs.",
  visitor_default_name: "Visiteur",
  visitor_without_name: "Visiteur sans nom",
  without_number: "Sans numéro",
  option_without_name: "Option sans nom",
  field_without_valid_source_url: "Le champ {field} a un sourceUrl invalide.",
  source_url: "URL source",
  active: "actif",
  add_field: "Ajouter un champ",
  add_new_field: "Ajouter un nouveau champ",
  all: "Tous",
  all_categories: "Toutes les catégories",
  back: "Retour",
  badge: "Badge",
  branch: "Branche",
  careful: "Attention",
  category: "Catégorie",
  center: "Centre",
  clear_search: "Effacer la recherche",
  close: "Fermer",
  "collaboratormail@decathlon.com": "collaborateur{'@'}decathlon.com",
  color: "Couleur",
  complete_required_info: "Complétez les informations obligatoires",
  created_collaborator: "Collaborateur créé",
  created_leader: "Leader créé",
  created_team: "Équipe créée",
  dangerous: "Dangereux",
  dangerous_process: "Processus dangereux",
  delete_field_description: "Vous êtes sur le point de supprimer un champ",
  delete_leader_description: "Vous êtes sur le point de supprimer un leader",
  deleted: "supprimé",
  deleted_field: "Champ supprimé",
  deleted_leader: "Leader supprimé",
  deleted_team: "Équipe supprimée",
  "email_without_@decathlon.com": "L'email doit contenir {'@'}decathlon.com",
  emails: "Emails",
  error_creating_process: "Erreur lors de la création du processus",
  error_updating: "Erreur lors de la mise à jour",
  exit_visitor: "Sortie visiteur",
  field_name: "Nom du champ",
  fields_not_found: "Champs introuvables",
  fill_required_fields: "Remplissez les champs obligatoires",
  from: "De",
  given_polyvalence: "Polyvalence donnée",
  hour_in: "Heure d'entrée",
  hour_out: "Heure de sortie",
  hour_out_is_smaller_than_hour_in: "L'heure de sortie est inférieure à l'heure d'entrée",
  impersonating: "Usurpation",
  invalid_email: "Email invalide",
  is_required: "est obligatoire",
  label: "Étiquette",
  liberate: "Libérer",
  link_href: "Lien",
  logout: "Déconnexion",
  mail: "Mail",
  max_hours_inversion: "Le maximum d'heures ne peut pas être inférieur au minimum",
  more_info: "Plus d'informations",
  new: "Nouveau",
  new_category: "Nouvelle catégorie",
  new_visitor: "Nouveau visiteur",
  no_categories_available: "Aucune catégorie disponible",
  no_custom_fields_added: "Aucun champ personnalisé ajouté",
  no_data_available: "Aucune donnée disponible",
  no_more_visitors: "Plus de visiteurs",
  no_visitors: "Aucun visiteur",
  optional: "Optionnel",
  placeholder: "Placeholder",
  press_enter_to_add_email: "Appuyez sur Entrée pour ajouter un email",
  preview_category_form: "Aperçu du formulaire de catégorie",
  process_created: "Processus créé",
  process_name: "Nom du processus",
  process_updated: "Processus mis à jour",
  remove_visitor_description: "Vous êtes sur le point d'enregistrer la sortie du visiteur",
  required: "Obligatoire",
  required_abreviation: "Obl.",
  required_field_error: "Champ obligatoire",
  required_filed_category_description: "La description de la catégorie est obligatoire",
  required_filed_category_name: "Le nom de la catégorie est obligatoire",
  reset_filters: "Réinitialiser les filtres",
  select_category: "Sélectionner une catégorie",
  select_fields_preview: "Aperçu des champs sélectionnés",
  select_inputs: "Sélectionner des inputs",
  select_option: "Sélectionner une option",
  service: "Service",
  subtype: "Sous-type",
  team_deleted: "Équipe supprimée",
  teams: "Équipes",
  to: "À",
  type: "Type",
  type_of_select: "Type de sélection",
  uid: "UID",
  updated_category: "Catégorie mise à jour",
  updated_leader: "Leader mis à jour",
  updated_site: "Site mis à jour",
  updated_team: "Équipe mise à jour",
  user: "Utilisateur",
  validation: "Validation",
  view: "Voir",
  visitor_data: "Données du visiteur",
  visitors_evacuation_download: "Évacuation",
  visitors_evacuation_download_error: "Impossible de télécharger le rapport d'évacuation",
  visitors: "Visiteurs",
  fields: "Champs",
  you_are_about_create_a_planning: "Vous êtes sur le point de créer une planification",
  you_are_about_delete_a_user: "Vous êtes sur le point de supprimer un utilisateur",
  you_are_about_to_delete_a_team: "Vous êtes sur le point de supprimer une équipe",
  search_by_name_or_badge: "Rechercher par nom ou badge...",
  visitor_site_form: {
    emails: "Emails",
    emails_placeholder: "Tapez un email et appuyez sur Entrée",
  },
  add: "Ajouter",
  delete_collaborator_description: "Vous êtes en train de supprimer un collaborateur",
  deleted_collaborator: "Collaborateur supprimé",
  search_by_mail: "Rechercher un collaborateur par email",
  user_not_found_or_error: "Utilisateur introuvable ou erreur",
  usurpation_completed: "Usurpation terminée",
  usurpate: "Usurper",
  search: "Rechercher",
  removed_team: "Équipe supprimée",
  updated_collaborator: "Collaborateur mis à jour",

  site_form: {
    name: "Site Name",
    name_placeholder: "Name",
    code: "Site code",
    code_placeholder: "Site code",
    code_fedid: "Site FEDID code",
    code_fedid_placeholder: "FEDID code",
    planning: "Connected to planning",
  },
  category_form: {
    name: "Category name",
    name_placeholder: "Name",
    desc: "Category description",
    desc_placeholder: "Description",
  },
  collaborator_form: {
    name: "Full name",
    name_placeholder: "Name",
    username: "Profile",
    username_placeholder: "Profile",
    dni: "DNI",
    dni_placeholder: "DNI",
    uuid: "UUID",
    uuid_placeholder: "Uuid",
    sap: "SAP number",
    sap_placeholder: "SAP number",
    email: "Email",
    email_placeholder: "Email",
    sites: "Select VADA sites",
    manual: "Manual user",
  },
  team_form: {
    name: "Name",
    name_placeholder: "Name",
    desc: "Description",
    des_placeholder: "Description",
    sap: "SAP number",
    sap_placeholder: "Número SAP number",
    uuid: "Uuid",
    uuid_placeholder: "Uuid",
  },

  bookings: {
    home: {
      title: "Gestion des prêts",
      description:
        "Ajoutez du matériel à votre panier depuis n'importe quelle catégorie et choisissez les dates lors de la validation",
      subtitleShort: "Consultez vos alertes de prêt et explorez le catalogue par type, catégorie ou recherche",
      browse: "Voir le catalogue",
      cart: "Mon panier",
      myReservations: "Mes réservations",
      adminPanel: "Panneau admin",
      searchTitle: "Rechercher du matériel",
      searchDescription: "Trouvez des produits dans tout le catalogue, quel que soit le type ou la catégorie",
      browseByType: "Parcourir par type",
      browseByTypeHint:
        "Optionnel : explorez le catalogue et combinez des produits de catégories différentes dans un même panier",
      alerts: {
        title: "Vos alertes",
        empty: "Aucun prêt ne nécessite d'action pour le moment",
        viewReservation: "Voir la réservation",
        viewReservations: "Mes réservations",
        localCartExpired: "Votre panier a expiré — videz-le ou recommencez",
        overdueReturn: "Retour en retard — date limite dépassée",
        returnToday: "Retour prévu aujourd'hui",
        returnTomorrow: "Retour prévu demain",
        deliveryOverdue: "Retrait en attente — la date de début est dépassée",
        deliveryToday: "Retrait prévu aujourd'hui",
        deliveryTomorrow: "Retrait prévu demain",
        cartExpiringSoon: "Réservation non validée — expire bientôt",
        cartExpired: "Réservation non validée — expirée",
      },
      recentProducts: {
        title: "Emprunter à nouveau",
        subtitle: "Matériel que vous avez récemment réservé",
      },
      explorer: {
        title: "Explorer le catalogue",
        subtitle: "Filtrez par type et catégorie ou recherchez des produits",
        searchPlaceholder: "Rechercher par nom, référence...",
        startHint: "Saisissez ou choisissez un filtre pour voir les produits ici",
        selectTypeHint: "Choisissez un type de matériel",
        selectCategoryHint: "Choisissez une catégorie",
        selectSubCategoryHint: "Choisissez une sous-catégorie",
        productsHint: "Produits disponibles dans cette sous-catégorie",
        searchResultsHint: "Résultats de recherche dans le catalogue",
        type: "Type",
        category: "Catégorie",
        subCategory: "Sous-catégorie",
        allTypes: "Tous",
        viewProducts: "Voir les produits",
        openCatalog: "Ouvrir le catalogue",
        clearFilters: "Effacer les filtres",
        noCategories: "Aucune catégorie disponible pour ce type",
        noSubCategories: "Aucune sous-catégorie dans cette catégorie",
      },
      calendar: {
        title: "Calendrier des prêts",
        previousMonth: "Mois précédent",
        nextMonth: "Mois suivant",
        legendRange: "Période du prêt",
        legendPickup: "Retrait",
        legendReturn: "Retour",
        bookedDay: "Jour du prêt : {date}",
        pickupDay: "Retrait : {date}",
        returnDay: "Retour : {date}",
        singleDay: "Retrait et retour : {date}",
      },
    },
    catalog: {
      title: "Catalogue",
      types: "Types de réservation",
      categories: "Catégories",
      subCategories: "Sous-catégories",
      products: "Produits",
      availableUnits: "0 unité disponible | 1 unité disponible | {count} unités disponibles",
      addToCart: "Ajouter au panier",
      viewProduct: "Voir le produit",
      addedToCart: "Produit ajouté au panier. Vous pouvez continuer à parcourir le catalogue.",
      quantity: "Unités",
      increaseQuantity: "Augmenter les unités",
      decreaseQuantity: "Réduire les unités",
      noUnits: "Aucune unité disponible",
      inCart: "0 dans le panier | 1 dans le panier | {count} dans le panier",
      unitsAvailable: "{available} / {total} disponibles",
      maxUnitsPerReservation: "Max. {count} par prêt",
      maxInCart: "Vous avez déjà le maximum disponible dans le panier",
      browseAndAdd:
        "Sélectionnez les quantités et ajoutez-les au panier. Les dates sont choisies lors de la validation.",
      availabilityOnCheckout: "La disponibilité finale sera vérifiée lors de la sélection des dates dans le panier.",
      searchResults: "Résultats de recherche",
      searchFilters: {
        title: "Filtres de recherche",
        subtitle: "Combinez texte, type, catégorie et sous-catégorie pour parcourir tout le catalogue",
        availableOnly: "Uniquement les produits avec unités disponibles",
        allCategories: "Toutes les catégories",
        allSubCategories: "Toutes les sous-catégories",
        resultsCount: "0 produit trouvé | 1 produit trouvé | {count} produits trouvés",
      },
      selectDates: "Sélectionnez les dates du prêt",
      noTypes: "Aucun type de réservation disponible",
      noCategories: "Aucune catégorie disponible",
      emptyCategoriesHint:
        "Ce type de réservation n'a pas encore de catégories. Revenez à l'accueil et essayez un autre type.",
      noSubCategories: "Aucune sous-catégorie disponible",
      noProducts: "Aucun produit disponible",
      available: "disponibles",
      default: "Par défaut",
      allProducts: "Tous les produits",
      subCategoriesHint: "Choisissez une sous-catégorie ou parcourez tous les produits de la catégorie",
      searchProducts: "Rechercher des produits...",
      emptyProducts: "Aucun produit dans l'inventaire",
      emptyTypes: "Aucun type de réservation créé",
      errorLoad: "Impossible de charger le catalogue",
      category: "Catégorie",
      subCategory: "Sous-catégorie",
      type: "Type",
      referenceCode: "Code de référence",
      maxDays: "Jours max. de réservation",
      maxUnits: "Unités max. par réservation",
      filters: {
        search: "Rechercher...",
        availability: "Disponibilité",
        status: "Statut",
        clear: "Effacer les filtres",
      },
    },
    productDetail: {
      description: "Description",
      specifications: "Informations produit",
      availability: "Disponibilité actuelle",
    },
    images: {
      image: "Image",
      file: "Fichier image",
      manage: "Images",
      upload: "Téléverser une image",
      altText: "Texte alternatif",
      markPrimary: "Définir comme image principale",
      primary: "Principale",
      setPrimary: "Définir principale",
      regenerate: "Régénérer",
      empty: "Aucune image",
      noAlt: "Sans texte alternatif",
    },
    cart: {
      title: "Mon panier",
      subtitle: "Vérifiez le matériel sélectionné et choisissez les dates pour valider la réservation",
      empty: "Votre panier est vide",
      browse: "Parcourir le catalogue",
      period: "Période de réservation",
      selectDates: "Dates du prêt",
      selectDatesHint: "Indiquez la période pendant laquelle vous aurez besoin du matériel",
      confirmRequiresDates: "Sélectionnez les dates avant de demander la réservation",
      datesLockedByReservation: "Les dates ne peuvent pas être modifiées pendant le traitement de la réservation",
      expired: "Panier expiré",
      expiresAt: "Expire à {time}",
      confirm: "Demander une réservation",
      cancel: "Annuler le panier",
      clear: "Vider",
      increase: "Augmenter la quantité",
      decrease: "Diminuer la quantité",
      remove: "Supprimer l'article",
      confirmTitle: "Confirmer la réservation ?",
      confirmText: "Une fois confirmée, les unités seront assignées.",
      continueBrowsing: "Continuer à parcourir",
      itemsTitle: "Matériel sélectionné",
      checkout: "Valider la réservation",
      summary: "Résumé",
      itemsCount: "Aucun produit | 1 produit | {count} produits",
    },
    notifications: {
      addedToCart: "Ajouté au panier",
      addedToCartDetail: "{name} × {count}",
      cartLimitReached: "Impossible d'ajouter plus d'unités",
      cartLimitReachedDetail: "Maximum autorisé : {max}",
      cartPartialAdd: "Seules certaines unités ont été ajoutées en raison du stock",
      removedFromCart: "Retiré du panier",
      cartCleared: "Panier vidé",
      cartCancelled: "Réservation en attente annulée",
      datesApplied: "Dates du prêt mises à jour",
      reservationSubmitted: "Demande de réservation envoyée",
      reservationPending: "Réservation créée. Confirmez pour finaliser.",
      reservationConfirmed: "Réservation confirmée",
      reservationCancelled: "Réservation annulée",
    },
    confirmation: {
      title: "Demande envoyée !",
      subtitle: "Votre demande de réservation a bien été enregistrée",
      pendingAdminDelivery:
        "Un administrateur confirmera la remise du matériel. Le retour sera également vérifié par l'équipe à la fin du prêt.",
      reservationId: "ID de réservation",
      reservationSummary: "Résumé de la réservation",
      period: "Période du prêt",
      viewMyReservations: "Voir mes réservations",
    },
    myReservations: {
      title: "Mes réservations",
      subtitle: "Consultez, filtrez et gérez toutes vos réservations de matériel",
      empty: "Vous n'avez aucune réservation",
      emptyFiltered: "Aucune réservation ne correspond aux filtres",
      emptyFilteredHint: "Essayez de modifier l'état, la période ou la recherche",
      itemsCount: "Aucun produit | 1 produit | {count} produits",
      detail: "Détail de la réservation",
      cancel: "Annuler la réservation",
      cancelConfirm: "Êtes-vous sûr de vouloir annuler cette réservation ?",
      download: "Télécharger le document",
      table: {
        id: "Référence",
        createdAt: "Demande",
      },
      filters: {
        title: "Filtrer les réservations",
        subtitle: "Affinez la liste par état, dates ou référence",
        searchPlaceholder: "Rechercher par centre, collaborateur ou ID...",
        stateGroup: "État",
        period: "Période",
        sort: "Trier par",
        expand: "Afficher les filtres",
        collapse: "Masquer les filtres",
        removeTag: "Retirer le filtre",
        resultCount: "Aucune réservation | 1 réservation trouvée | {count} réservations trouvées",
        showingRange: "Affichage de {from} à {to} sur {total}",
        sortNewest: "Plus récentes",
        sortOldest: "Plus anciennes",
        sortFromDateAsc: "Date de début (croissant)",
        sortFromDateDesc: "Date de début (décroissant)",
        groups: {
          all: "Toutes",
          active: "Actives",
          inProgress: "En cours",
          completed: "Terminées",
          cancelled: "Annulées",
        },
        periods: {
          all: "Toutes les dates",
          upcoming: "À venir",
          thisMonth: "Ce mois-ci",
          last3Months: "3 derniers mois",
          custom: "Plage personnalisée",
        },
        tags: {
          search: "Recherche : {query}",
          customRange: "{from} → {to}",
        },
      },
    },
    checkout: {
      title: "Confirmation de réservation",
      success: "Réservation créée avec succès",
      viewDetail: "Voir le détail",
      pending: "En attente de confirmation",
      confirm: "Confirmer",
    },
    confirm: {
      deleteTitle: "Confirmer la suppression ?",
      deleteMessage: "Cette action est irréversible.",
      deleteNamedMessage: "« {name} » sera supprimé.",
      cancelCartTitle: "Annuler le panier ?",
      cancelCartMessage: "Les articles sélectionnés et la réservation en attente seront perdus.",
      clearCartTitle: "Vider le panier ?",
      clearCartMessage: "Tous les articles seront retirés du panier.",
      removeCartItemTitle: "Supprimer l'article ?",
      removeCartItemMessage: "« {name} » sera retiré du panier.",
      cancelReservationTitle: "Annuler la réservation ?",
      cancelReservationMessage: "La réservation sera annulée. Cette action est irréversible.",
      closeMaintenanceTitle: "Clôturer la maintenance ?",
      closeMaintenanceMessage: "L'unité redeviendra disponible dans l'inventaire.",
      pickupTitle: "Confirmer la remise",
      pickupMessage: "Confirmez-vous que le matériel a été remis au collaborateur ?",
      returnTitle: "Confirmer la réception",
      returnMessage: "Confirmez-vous la réception et l'état du matériel retourné ?",
      submitReservationTitle: "Confirmer la réservation ?",
      submitReservationMessage: "Une fois confirmée, les unités seront assignées.",
    },
    nav: {
      home: "Accueil",
      back: "Retour",
      backToHome: "Retour à l'accueil",
      backToBooking: "Retour aux réservations",
      employeeSection: "Navigation réservations",
      adminSection: "Navigation administration",
      quickAccess: "Accès rapide",
    },
    flow: {
      title: "Progression de la réservation",
      stepType: "Type",
      stepCategory: "Catégorie",
      stepSubCategory: "Sous-catégorie",
      stepProducts: "Produits",
      stepCart: "Panier et dates",
      stepConfirm: "Confirmation",
    },
    states: {
      ALL: "Toutes",
      PENDING_CHECKOUT: "En cours de traitement",
      BOOKED: "Demandée",
      PICKED_UP: "En cours d'utilisation",
      RETURNED: "Retournée",
      RETURNED_WITH_INCIDENT: "Retournée avec incident",
      CANCELLED: "Annulée",
      CANCELLED_ADMIN: "Annulée (admin)",
      EXPIRED: "Expirée",
    },
    unitStates: {
      AVAILABLE: "Disponible",
      RESERVED: "Réservée",
      IN_USE: "En cours d'utilisation",
      IN_MAINTENANCE: "En maintenance",
      LOST: "Perdue",
      RETIRED: "Retirée",
      DAMAGED: "Endommagée",
    },
    units: {
      title: "Unités",
      serialNumber: "Numéro de série",
      state: "État",
      location: "Emplacement",
      history: "Historique",
      noUnits: "Aucune unité enregistrée pour ce produit",
      noHistory: "Pas d'historique de changement d'état",
      placeholder: "Pas d'informations supplémentaires",
    },
    admin: {
      common: {
        resultCount: "Aucun résultat | 1 résultat | {count} résultats",
        searchName: "Rechercher par nom",
      },
      dashboard: {
        title: "Tableau de bord admin",
        subtitle: "Supervisez l'activité quotidienne et accédez aux outils de gestion du centre.",
        overview: "Résumé opérationnel",
        overviewHint: "Indicateurs clés d'activité et alertes du jour.",
        operations: "Opération quotidienne",
        operationsHint: "Gestion des réservations, du stock et de la maintenance.",
        control: "Contrôle et analyse",
        controlHint: "Audit, métriques et configuration du catalogue.",
        alert: "Attention",
        pendingPickups: "Livraisons en attente",
        pendingReturns: "Réceptions en attente",
        inMaintenance: "En maintenance",
        expiredReservations: "Réservations expirées",
        todayReservations: "Demandes aujourd'hui",
        attentionAlerts: "Alertes actives",
        sections: "Sections",
        partialError: "Certaines données n'ont pas pu être chargées. Le reste du tableau de bord est disponible.",
        activityTitle: "Activité (7 derniers jours)",
        maintenanceHint: "Unités bloquées en attente de clôture de maintenance.",
        maintenanceViewAll: "Voir toutes les maintenances",
        alertList: {
          title: "Centre d'attention",
          hint: "Réservations nécessitant une action immédiate : retards, expirations et alertes.",
        },
        quickActions: {
          title: "Actions rapides",
          viewAllDeliveries: "Voir toutes les livraisons",
          viewAllReturns: "Voir toutes les réceptions",
        },
        inventoryRisk: {
          section: "Stock critique",
          title: "Produits à faible disponibilité ou indisponibles",
          hint: "Produits avec 0 unités disponibles ou moins de 25 % de leur stock libre.",
          empty: "Aucun produit en stock critique",
          product: "Produit",
        },
      },
      reservations: {
        title: "Gestion des réservations",
        description: "Vérifiez les remises et réceptions. Trouvez une réservation par collaborateur ou référence.",
        empty: "Aucune réservation à afficher",
        emptyHint: "Essayez une autre recherche ou changez d'onglet.",
        emptyDeliveries: "Aucune remise en attente",
        emptyReturns: "Aucune réception en attente",
        emptyAttention: "Aucune alerte opérationnelle",
        searchLabel: "Rechercher une réservation",
        searchPlaceholder: "Collaborateur, référence ou centre…",
        refresh: "Actualiser",
        viewDetail: "Voir le détail",
        confirmDeliveryPrompt: "Confirmez-vous que le matériel a été remis au collaborateur ?",
        tabsLabel: "Files opérationnelles",
        tabs: {
          deliveries: "Remises",
          returns: "Réceptions",
          attention: "Attention",
          all: "Toutes",
        },
        queues: {
          deliveries: "Remises en attente",
          returns: "Réceptions en attente",
          delays: "Retards",
          expiringSoon: "Expiration proche",
          deliveriesTitle: "File de remises",
          returnsTitle: "File de réceptions",
          deliveriesHint: "Réservations demandées en attente de remise physique du matériel.",
          returnsHint: "Matériel en usage en attente de réception et vérification au retour.",
        },
        attention: {
          title: "Nécessite une attention",
          subtitle:
            "Retards, retours en retard ou réservations sur le point d'expirer. Contactez le collaborateur responsable.",
          viewAll: "Tout voir",
          overdueReturn: "Retour en retard — contacter le collaborateur",
          returnToday: "Retour prévu aujourd'hui",
          returnTomorrow: "Retour prévu demain",
          deliveryOverdue: "Remise en retard — la date de début du prêt est dépassée",
          deliveryToday: "Remise prévue aujourd'hui",
          deliveryTomorrow: "Remise prévue demain",
          cartExpiringSoon: "Panier sur le point d'expirer",
          cartExpired: "Panier expiré ou réservation non finalisée",
        },
      },
      inventory: {
        title: "Inventaire",
        totalUnits: "Unités totales",
        availableUnits: "Disponibles",
        reservedUnits: "Réservées",
        maintenanceUnits: "En maintenance",
        description: "Consultez le stock des produits et unités",
        total: "Total",
        available: "Disponibles",
        stockLevel: "Niveau de stock",
        stockSummary: "{available} / {total} disponibles",
        stockBarLabel: "Stock disponible {available} sur {total}",
        inUseOrUnavailable: "Indisponibles",
        addProduct: "Nouveau produit",
        autoMaintenanceOnReturn: "Envoyer automatiquement en maintenance au retour",
      },
      units: {
        title: "Unités",
        serialNumber: "Numéro de série",
        state: "État",
        location: "Emplacement",
        history: "Historique",
        noUnits: "Aucune unité enregistrée pour ce produit",
        noHistory: "Pas d'historique de changement d'état",
        placeholder: "Pas d'informations supplémentaires",
      },
      maintenance: {
        title: "Maintenance",
        open: "Maintenances ouvertes",
        close: "Fermer la maintenance",
        noMaintenance: "Aucune maintenance active",
        description: "Gérez les unités en maintenance",
      },
      audit: {
        title: "Audit",
        noEvents: "Aucun événement d'audit",
        detail: "Détail de l'événement",
        description: "Consultez l'historique d'activité du module de réservations",
        filtersTitle: "Filtrer les événements",
        filtersSubtitle: "Affinez par période ou type d'événement pour la traçabilité",
        eventTypePlaceholder: "Type d'événement (ex. PICKED_UP)",
        quickFilters: "Accès rapides",
        chips: {
          all: "Tous",
          reservations: "Réservations",
          pickups: "Remises",
          returns: "Réceptions",
          cancelled: "Annulations",
        },
        fields: {
          aggregate: "Agrégat",
          correlation: "Corrélation",
          payload: "Données de l'événement",
        },
      },
      analytics: {
        title: "Analytique",
        reservations: "Réservations",
        utilization: "Utilisation",
        description: "Métriques et tendances du module de réservations",
        noData: "Pas de données pour la période sélectionnée",
        confirmed: "Demandes enregistrées",
        filtersTitle: "Période d'analyse",
        filtersSubtitle: "Sélectionnez une plage de dates ou un raccourci",
        periodSummary: "Métriques du {from} au {to}",
        dailyBreakdown: "Détail quotidien",
        dailyBreakdownHint: "Évolution des demandes, remises et réceptions par jour",
        presets: {
          last7: "7 derniers jours",
          last30: "30 derniers jours",
          last90: "90 derniers jours",
        },
        charts: {
          dailyTrend: "Activité quotidienne",
          dailyTrendHint: "Comparaison jour par jour des demandes, remises, réceptions et annulations",
          periodMix: "Répartition de la période",
          periodMixHint: "Poids relatif de chaque type d'opération sur la plage filtrée",
          confirmed: "Demandes",
          total: "Total",
          noActivity: "Aucune activité enregistrée sur cette période",
        },
      },
      catalog: {
        title: "Catalogue",
        description: "Gérez types, catégories, sous-catégories et produits",
        filtersTitle: "Filtres du catalogue",
        filtersSubtitle: "Sélectionnez le niveau et recherchez par nom",
        tableTypes: "Types de réservation",
        tableCategories: "Catégories",
        tableSubCategories: "Sous-catégories",
        addType: "Nouveau type",
        addCategory: "Nouvelle catégorie",
        addSubCategory: "Nouvelle sous-catégorie",
        selectType: "Sélectionnez un type",
        selectCategory: "Sélectionnez une catégorie",
        status: "État",
        enabled: "Activé",
        disabled: "Désactivé",
        confirmDelete: "Confirmer la suppression ?",
      },
      actions: {
        managementTitle: "Vérification du matériel",
        pickup: "Confirmer la remise",
        pickupHint: "Vérifiez que le matériel a bien été remis au collaborateur avant de confirmer.",
        return: "Confirmer la réception",
        returnHint: "Vérifiez l'état du matériel restitué à la fin du prêt.",
        noActionHint: "Aucune action en attente pour cet état.",
        cancel: "Annuler la réservation",
        createType: "Créer un type",
        editType: "Modifier le type",
        createProduct: "Créer un produit",
        editProduct: "Modifier le produit",
        addUnit: "Ajouter une unité",
        changeState: "Changer l'état",
        returnCondition: "État du matériel restitué",
        conditionGood: "Bon",
        conditionDamaged: "Endommagé",
        conditionLost: "Perdu",
        incidentNotes: "Notes d'incident",
        deliveryConfirmed: "Remise confirmée",
        returnConfirmed: "Réception confirmée",
      },
      reservationDetail: {
        timeline: "Historique",
        requestedAt: "Demande enregistrée",
        deliveredAt: "Remise confirmée",
        returnedAt: "Réception confirmée",
      },
    },
    filters: {
      state: "État",
      searchPlaceholder: "Rechercher...",
      clear: "Effacer",
      fromDate: "De",
      toDate: "À",
    },
    reservation: {
      collaborator: "Collaborateur",
      dates: "Dates",
      state: "État",
      items: "Produits",
      center: "Centre",
      dateRangeCalendar: {
        ariaLabel: "Calendrier de réservation du {range}",
        legendRange: "Période du prêt",
        legendPickup: "Retrait",
        legendReturn: "Retour",
        selectedDay: "Retrait et retour : {date}",
        startDay: "Retrait : {date}",
        endDay: "Retour : {date}",
        inRangeDay: "Jour du prêt : {date}",
      },
    },
    items: "produits",
    detail: {
      cancel: "Annuler la réservation",
    },
    errors: {
      BOOKING_RESERVATION_EXPIRED: "La réservation a expiré",
      BOOKING_INSUFFICIENT_AVAILABILITY: "Disponibilité insuffisante",
      BOOKING_INVALID_DATE_RANGE: "Plage de dates invalide",
      BOOKING_FORBIDDEN_CENTER: "Vous n'avez pas accès à ce centre",
      BOOKING_INVALID_STATE: "État de réservation invalide",
      loadFailed: "Erreur lors du chargement des données",
    },
  },

  common: {
    view: "Voir",
    confirm: "Confirmer",
    cancel: "Annuler",
    apply: "Appliquer",
    date: "Date",
    search: "Rechercher",
    type: "Type",
    actor: "Acteur",
    close: "Fermer",
  },

  pagination: {
    prev: "Précédent",
    next: "Suivant",
  },

  no_role_title: "Pas d'accès",
  no_role_description:
    "Votre compte n'a aucun rôle attribué. Veuillez contacter votre administrateur pour demander l'accès.",
  no_role_contact: "Contacter le support",
  langue: "language",

};

export default message;
